import _ from 'lodash';

const getNbProducts = (state) =>{
  if(state.stats==null) return 0;
  else return state.stats.total;
}
const getNbProductsToString = (state) =>{
  if(state.stats==null) return "0";
  else return state.stats.total.toString();
}

const getNbActiveProduct = (state) =>{
  if(state.stats==null) return 0;
  else return state.stats.active;
}
const getNbActiveProductToString = (state) =>{
  if(state.stats==null) return "0";
  else return state.stats.active.toString();
}

const getNbInactiveProduct = (state) =>{
  if(state.stats==null) return 0;
  else return state.stats.total-state.stats.active;
}
const getNbInactiveProductToString= (state) =>{
  if(state.stats==null) return "0";
  else return (state.stats.total-state.stats.active).toString();
}

const listServiceProduct = (state) =>{
  let serviceProducts = [];
  _.forEach(state.products, p=>{
    if(p.type==0)serviceProducts.push(p);
  })

  return serviceProducts;
}

const isFiltered = (state) => {
  return false;
}

const getFilterPublishedInd = (state) => {

  const ind = state.origin === 'CMS' ? state.productFilters.cmsProducPublishedInd : state.productFilters.producPublishedInd

  if (ind === true) {
    return 1;
  } else if (ind === false) {
      return 0;
  }
  return 2;
}

const getFilterCheckedTags = (state) => {

  return state.origin === 'CMS' ? state.productFilters.cmsCheckedTags : state.productFilters.checkedTags


}

const getFilterProductActive = (state) => {

  const ind = state.origin === 'CMS' ? state.productFilters.cmsActive : state.productFilters.active;
  if (ind === true) {
    return 1;
  } else if (ind === false) {
      return 0;
  }
  return 2;

}



export default {
  getNbProducts,
  getNbProductsToString,
  getNbActiveProduct,
  getNbActiveProductToString,
  getNbInactiveProduct,
  getNbInactiveProductToString,
  listServiceProduct,
  isFiltered,
  getFilterPublishedInd,
  getFilterCheckedTags,
  getFilterProductActive,
};
